import { useAuth } from "domain/authentication";
import { Navigate, Outlet } from "react-router-dom";
import { routes } from "router";
import { WithChildren } from "types";

type Props = WithChildren<{
  redirect?: string;
}>;

export const ProtectedRoute = ({
  children,
  redirect = routes.SIGNIN,
}: Props) => {
  const { user } = useAuth();

  if (!user) {
    if (redirect.startsWith("http")) {
      window.location.replace(redirect);
      return null;
    }

    return <Navigate to={redirect} replace />;
  }

  return <>{children}</> || <Outlet />;
};
